import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "book-cover-stack" }
const _hoisted_2 = {
  key: 0,
  class: "book-cover-stack__cover book-cover-stack__cover--fallback"
}
const _hoisted_3 = ["src", "alt", "onError"]

import { computed, ref } from 'vue'

import BookFallbackCover from '@/app/components/book/card/BookFallbackCover.vue'
import type { InterestBook } from '@/helpers/billingSourceBook'
import {
  getBookCoverStackSlugs,
  getBookCoverUrl,
  titleFromBookSlug,
} from '@/helpers/bookCoverStack'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookCoverStack',
  props: {
    book: {}
  },
  setup(__props: any) {

const props = __props

const coverErrors = ref<Set<string>>(new Set())

const covers = computed(() => {
  return getBookCoverStackSlugs(props.book).map((slug) => {
    const isSource = slug === props.book.url_slug
    return {
      slug,
      title: isSource ? props.book.title : titleFromBookSlug(slug),
      subtitle: isSource ? props.book.author || '' : '',
      url:
        isSource && props.book.cover_image
          ? props.book.cover_image
          : getBookCoverUrl(slug),
      useFallback:
        coverErrors.value.has(slug) || (isSource && !props.book.cover_image),
    }
  })
})

function onCoverError(slug: string): void {
  coverErrors.value = new Set([...coverErrors.value, slug])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(covers.value, (cover) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: cover.slug
      }, [
        (cover.useFallback)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(BookFallbackCover, {
                title: cover.title,
                subtitle: cover.subtitle
              }, null, 8, ["title", "subtitle"])
            ]))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: cover.url,
              alt: cover.title,
              class: "book-cover-stack__cover",
              onError: ($event: any) => (onCoverError(cover.slug))
            }, null, 40, _hoisted_3))
      ], 64))
    }), 128))
  ]))
}
}

})